import React, { useEffect, useMemo, useRef, useState } from "react";
import css from "../../../css/modules/toolbar.module.scss";
import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import Check from "@mui/icons-material/Check";
import clsx from "clsx";

export function MultiselectDropdown({
  items,
  descriptionKey,
  onItemsChange,
  itemKey,
  placeholder,
  placeholderSelected,
}) {
  const [value, setValue] = useState("");
  const [valueText, setValueText] = useState("");
  const [values, setValues] = useState({});
  const [open, setOpen] = useState(false);

  const onChange = (e) => {
    setValue(e.target.value);
    setOpen(true);
  };
  const onOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    ref.current.value = "";
  };
  const ref = useRef();
  const filteredList = useMemo(() => {
    if (!value) {
      return items;
    }
    return items.filter((i) => i[descriptionKey].toLowerCase().includes(value.toLowerCase()));
  }, [items, value, descriptionKey]);
  const onToggleValue = (i) => {
    setValues((values) => {
      const res = {
        ...values,
        [i[itemKey]]: values[i[itemKey]] ? undefined : i,
      };
      Object.keys(res).forEach((i) => {
        if (res[i] === undefined) {
          delete res[i];
        }
      });
      onItemsChange(Object.values(res).map((i) => i[itemKey]));
      return res;
    });
  };
  useEffect(() => {
    const items = Object.values(values)
      .filter((i) => !!i)
      .map((i) => i[itemKey]);
    let label =
      items.length === 1
        ? values[items[0]][descriptionKey]
        : items.length
        ? `${items.length} ` + placeholderSelected
        : "";
    setValueText(label);
  }, [values, itemKey, placeholderSelected, descriptionKey]);
  const onClear = () => {
    setValues({});
    onItemsChange([]);
    ref.current.value = "";
  };
  return (
    <>
      <div className={css.departmentSelect}>
        <input
          type="text"
          className={css.autoComplete}
          ref={ref}
          onClick={onOpen}
          onChange={onChange}
          placeholder={valueText || placeholder}
        />
        {valueText && <span onClickCapture={onClear} className={clsx("ico icon-cross", css.clear)} />}
        <Popper open={open && !!filteredList.length} anchorEl={ref.current} role={undefined} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              in={!!TransitionProps.in}
              style={{ transformOrigin: placement === "bottom" ? "center top" : "center bottom" }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList className={css.dropDownMenu}>
                    {filteredList?.map((i) => {
                      return (
                        <MenuItem key={i[itemKey]} onClick={() => onToggleValue(i)}>
                          {values[i[itemKey]] && <Check className={css.checkIcon} />}
                          {i[descriptionKey]}
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </>
  );
}
